export default __webpack_public_path__ + "assets/burger.svg?b0597913b38f098886ef50d761003fa6";